/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_Stripe_TextInputs */

const en_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit card`)
};

const id_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kartu kredit`)
};

const ms_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kad kredit`)
};

const ca_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Targeta de crèdit`)
};

const cs_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditní karta`)
};

const da_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditkort`)
};

const de_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditkarte`)
};

const et_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krediitkaart`)
};

const es_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjeta de crédito`)
};

const fr_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carte de crédit`)
};

const hr_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditna kartica`)
};

const it_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carta di credito`)
};

const lv_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bankas karte`)
};

const lt_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredito kortelė`)
};

const hu_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitelkártya`)
};

const nl_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creditcard`)
};

const nb_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalingskort`)
};

const pl_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karty kredytowe`)
};

const pt_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartão de crédito`)
};

const ro_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Card de credit`)
};

const sk_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditná karta`)
};

const sl_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditna kartica`)
};

const fi_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luottokortti`)
};

const sv_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreditkort`)
};

const vi_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ tín dụng`)
};

const tr_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kredi kartı`)
};

const el_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πιστωτική κάρτα`)
};

const bg_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кредитна карта`)
};

const ru_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кредитная карта`)
};

const sr_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кредитна картица`)
};

const uk_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кредитна карта`)
};

const ka_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`საკრედიტო ბარათი`)
};

const hi_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्रेडिट कार्ड `)
};

const th_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บัตรเครดิต`)
};

const ko_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`신용 카드`)
};

const zh_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信用卡`)
};

const zh_tw_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信用卡`)
};

const ja_payment_stripe_text = /** @type {(inputs: Payment_Stripe_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クレジットカード`)
};

/**
* | output |
* | --- |
* | "Credit card" |
*
* @param {Payment_Stripe_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const payment_stripe_text = /** @type {((inputs?: Payment_Stripe_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_Stripe_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_payment_stripe_text(inputs)
	if (locale === "ms") return ms_payment_stripe_text(inputs)
	if (locale === "ca") return ca_payment_stripe_text(inputs)
	if (locale === "cs") return cs_payment_stripe_text(inputs)
	if (locale === "da") return da_payment_stripe_text(inputs)
	if (locale === "de") return de_payment_stripe_text(inputs)
	if (locale === "et") return et_payment_stripe_text(inputs)
	if (locale === "es") return es_payment_stripe_text(inputs)
	if (locale === "fr") return fr_payment_stripe_text(inputs)
	if (locale === "hr") return hr_payment_stripe_text(inputs)
	if (locale === "it") return it_payment_stripe_text(inputs)
	if (locale === "lv") return lv_payment_stripe_text(inputs)
	if (locale === "lt") return lt_payment_stripe_text(inputs)
	if (locale === "hu") return hu_payment_stripe_text(inputs)
	if (locale === "nl") return nl_payment_stripe_text(inputs)
	if (locale === "nb") return nb_payment_stripe_text(inputs)
	if (locale === "pl") return pl_payment_stripe_text(inputs)
	if (locale === "pt") return pt_payment_stripe_text(inputs)
	if (locale === "ro") return ro_payment_stripe_text(inputs)
	if (locale === "sk") return sk_payment_stripe_text(inputs)
	if (locale === "sl") return sl_payment_stripe_text(inputs)
	if (locale === "fi") return fi_payment_stripe_text(inputs)
	if (locale === "sv") return sv_payment_stripe_text(inputs)
	if (locale === "vi") return vi_payment_stripe_text(inputs)
	if (locale === "tr") return tr_payment_stripe_text(inputs)
	if (locale === "el") return el_payment_stripe_text(inputs)
	if (locale === "bg") return bg_payment_stripe_text(inputs)
	if (locale === "ru") return ru_payment_stripe_text(inputs)
	if (locale === "sr") return sr_payment_stripe_text(inputs)
	if (locale === "uk") return uk_payment_stripe_text(inputs)
	if (locale === "ka") return ka_payment_stripe_text(inputs)
	if (locale === "hi") return hi_payment_stripe_text(inputs)
	if (locale === "th") return th_payment_stripe_text(inputs)
	if (locale === "ko") return ko_payment_stripe_text(inputs)
	if (locale === "zh") return zh_payment_stripe_text(inputs)
	if (locale === "zh-tw") return zh_tw_payment_stripe_text(inputs)
	if (locale === "ja") return ja_payment_stripe_text(inputs)
	return en_payment_stripe_text(inputs)
});